export default () => {
  console.log('Requesting new tokens...');
  //Hub.dispatch('disconnect');
}
